import { DateRangeSelection } from '@shared/components'
import React from 'react'

import { FilterActions, useFiltersContext } from '@/context'

export const ScheduledCommunicationScheduledDateFilter = () => {
  const [{ scheduledCommunicationsFilters }, FilterDispatch] = useFiltersContext()
  const { start, end } = scheduledCommunicationsFilters.scheduledDatetime || {}

  return (
    <div className="relative flex flex-col w-full md:w-auto lg:flex">
      <DateRangeSelection
        endDate={end}
        headerTitle="Scheduled Date"
        listFilter={true}
        pastSelection={true}
        setEndDate={(d?: Date) => {
          FilterDispatch(
            FilterActions.setFilters({
              filterName: 'scheduledCommunications',
              filters: {
                scheduledDatetime: {
                  end: d,
                },
              },
            }),
          )
        }}
        setStartDate={(d?: Date) => {
          FilterDispatch(
            FilterActions.setFilters({
              filterName: 'scheduledCommunications',
              filters: {
                scheduledDatetime: {
                  start: d,
                },
              },
            }),
          )
        }}
        startDate={start}
      />
    </div>
  )
}
